var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineToolSidePanel = function SvgLineToolSidePanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.75,
    d: "m9.453 15.73 3.407-.803M14.928 12.922l.79-3.41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.799,
    cy: 16.084,
    r: 1.499,
    stroke: "currentColor",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.534,
    cy: 14.51,
    r: 1.499,
    stroke: "currentColor",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.202,
    cy: 7.92,
    r: 1.499,
    stroke: "currentColor",
    strokeWidth: 0.6
  })));
};
export default SvgLineToolSidePanel;